import React, { useRef, useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogContent,
  IconButton,
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { FaFilePdf, FaTimes, FaPencilAlt, FaFont, FaSave, FaEraser, FaUndo, FaRedo } from "react-icons/fa";
import { Loader } from "@egovernments/digit-ui-react-components";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { addFormMTDoc } from "@egovernments/digit-ui-module-core/src/redux/actions/formMT";
import axios from "axios";
import { PdfViewerModal } from "@egovernments/digit-ui-module-common/src/sharedComponents/PdfViewerModal";
// Create a new component for PDF viewing and editing

const Step3 = ({ formData, handleTabChange, isEmployee, isNocModule }) => {
  console.log("formDataInStep3", formData?.natureOfConstruction);
  const isCompounding = formData?.natureOfConstruction === "Compounding";
  const { t } = useTranslation();
  const { handleSubmit, control, setValue, watch, reset } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const scrutinyFlow = formData?.scrutinyFlow === "PDF" || Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION") === "PDF";
  const [drawingDetail, setDrawingDetail] = useState(formData?.drawingDetail || []);
  const drawingPdfflow = formData?.documents?.filter((e) => e.documentType === "drawingPdf") || [];
  const scrutinydxf = formData?.documents?.filter((e) => e.documentType === "dxfDrawing") || [];
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: "",
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const formRef = useRef(null);
  const onSubmit = () => {
    OpenPDFFromB64InPdfViewer();
  };
  const validatePdfUrl = (url) => {
    try {
      const urlObj = new URL(url);
      console.log("PDF URL validation:", {
        protocol: urlObj.protocol,
        hostname: urlObj.hostname,
        pathname: urlObj.pathname,
        search: urlObj.search,
        isValid: true,
      });
      return true;
    } catch (error) {
      console.error("Invalid PDF URL:", url, error);
      return false;
    }
  };
  console.log(drawingPdfflow, "pdfFlowwwww");
  const handleOpenPdf = async (url, index = null) => {
    console.log("DEBUG: handleOpenPdf called with URL:", url);
    // Validate URL before setting it
    if (!validatePdfUrl(url)) {
      showMessage("Invalid PDF URL provided", "error");
      return;
    }
    setCurrentPdfUrl(url);
    setCurrentDocumentIndex(index);
    setPdfModalOpen(true);
    console.log("DEBUG: PDF modal opened");
  };
  const handlePdfSave = (fileStoreId, documentIndex) => {
    console.log("PDF saved with fileStoreId:", fileStoreId, "for document index:", documentIndex);
    setSavedFileStoreId(fileStoreId);
    try {
      const workflow = {
        action: "NOWORKFLOW",
        comments: "",
      };
      const updatedDrawingDetail = drawingDetail.map((item) => ({
        ...item,
        viewEditPdf: fileStoreId,
      }));
      const appData = {
        ...formData,
        workflow,
        drawingDetail: updatedDrawingDetail,
      };
      updateApiCall.mutate(
        { BPA: appData },
        {
          onSuccess: (result) => {
            console.log("resultFromUpdate", result);
            onSelect("", result?.BPA?.[0]);
            // setDeveloperUpdateDocument("DocumentDetailsUpdated");
            alert("Pdf Edited Succesfully");
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
    // Update the drawingDetail array with the new fileStoreId
    // if (documentIndex !== null && documentIndex !== undefined) {
    //   const updatedDrawingDetail = [...drawingDetail];
    //   updatedDrawingDetail[documentIndex] = {
    //     ...updatedDrawingDetail[documentIndex],
    //     viewEditPdfUrl: `/filestore/v1/files/id?fileStoreId=${fileStoreId}&tenantId=up&module=property-upload`,
    //   };
    //   setDrawingDetail(updatedDrawingDetail);
    // Also update the formData if needed
    // if (formData && formData.drawingDetail) {
    //   formData.drawingDetail[documentIndex] = updatedDrawingDetail[documentIndex];
    // }
    // }
  };
  const columns = [
    { id: "submissionIndex", label: "Submission", accessor: "" },
    { id: "viewPdf", label: "View Pdf", accessor: "viewPdf" },
    { id: "viewEditPdfUrl", label: "View Edited Pdf", accessor: "viewEditPdfUrl" },
    { id: "viewPlanReport", label: "View Plan Report", accessor: "viewPlanReport" },
    { id: "dxfFile", label: "DXF File", accessor: "dxfFile" },
    { id: "status", label: "Status", accessor: "status" },
    { id: "submittedOn", label: "Submitted On", accessor: "submittedOn" },
    { id: "signedPdfUrl", label: "Digital Sign", accessor: "signedPdfUrl" },
  ];
  const pdfcolumns = [
    { id: "submissionIndex", label: "Submission", accessor: "" },
    { id: "dxfFile", label: "DXF File", accessor: "dxfFile" },
    { id: "drawingPdf", label: "Drawing Pdf", accessor: "drawingPdf" },
    { id: "signedPdfUrl", label: "Digital Sign", accessor: "signedPdfUrl" },
  ];
  const handleClose = () => {
    setOpen(false);
  };
  const handlePdfModalClose = () => {
    setPdfModalOpen(false);
    setCurrentPdfUrl("");
    setCurrentDocumentIndex(null);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: formData?.applicationNo,
        pdfType: "D",
      };
      const getSign = await Digit.DscService.getSignParams({ SignRequest });
      setSigningParams((prev) => ({
        ...prev,
        AuthToken: getSign?.SigningParameters?.authToken,
        SrcPdfB64: getSign?.SigningParameters?.pdfBase64,
        SignSettingName: getSign?.SigningParameters?.signSettingName,
        ReturnUrl: getSign?.SigningParameters?.returnURL,
        UserDataJson: getSign?.SigningParameters?.UserDataJson,
      }));
      setOpen(true);
      setLoading(false);
    } catch (error) {
      console.error(error, "error");
    }
  };
  const getFileStoreId = (url) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.searchParams.get("fileStoreId");
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  };
  const viewEdittedPdf = (url, index) => {
    window.open(url, "_blank");
  };
  const viewPdf = (url, index) => {
    window.open(url, "_blank");
  };
  const handleOpenDoc = async (url) => {
    const fileStoreId = getFileStoreId(url);
    try {
      await getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading);
    } catch (error) {
      console.error("Error loading document:", error);
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const { AuthToken, SrcPdfB64 } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading || isPreviewLoading) {
    return <Loader />;
  }
  return (
    <section className="groupContainer">
      <form ref={formRef}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{scrutinyFlow ? t("Pdf Document") : t("Drawing")}</h2>
          </div>
        </div>

        <TableContainer component={Paper} sx={{ marginBottom: "20px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="drawing details  table">
            <TableHead
              sx={{
                backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
                color: "#fff",
              }}
            >
              <TableRow sx={{ height: "20px" }}>
                {!scrutinyFlow
                  ? columns.map((column) => (
                      <TableCell key={column.id} sx={{ color: "#fff" }}>
                        {column.label}
                      </TableCell>
                    ))
                  : pdfcolumns?.map((column) => (
                      <TableCell key={column.id} sx={{ color: "#fff" }}>
                        {column.label}
                      </TableCell>
                    ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {!scrutinyFlow ? (
                drawingDetail.map((row, index) => (
                  <TableRow key={index}>
                    {columns.map((column) => {
                      if (column.id === "submissionIndex") {
                        return <TableCell key={column.id}>Upload Drawing PDF {index + 1}</TableCell>;
                      }
                      const value = row[column.accessor];
                      if (column.accessor === "submittedOn") {
                        return <TableCell key={column.id}>{value ? new Date(value).toLocaleString() : "N/A"}</TableCell>;
                      }
                      if (
                        column.accessor === "updatedDxfFile" ||
                        column.accessor === "planReport" ||
                        column.accessor === "viewPdf" ||
                        column.accessor === "viewPlanReport"
                      ) {
                        return (
                          <TableCell key={column.id}>
                            {value ? (
                              <FaFilePdf
                                color="#a10505"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleOpenPdf(value, index)}
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      if (column.accessor === "viewPdf") {
                        return (
                          <TableCell key={column.id}>
                            {value ? (
                              <FaFilePdf
                                color="#157CB3"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => viewPdf(value, index)}
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      if (column.accessor === "viewEditPdfUrl") {
                        return (
                          <TableCell key={column.id}>
                            {value ? (
                              <FaFilePdf
                                color="#157CB3"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => viewEdittedPdf(value, index)}
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      if (column.accessor === "dxfFile") {
                        return (
                          <TableCell key={column.id}>
                            {value ? (
                              <img
                                src="https://i.imgur.com/GDoAGny.png"
                                style={{
                                  width: "20px",
                                  height: "30px",
                                  cursor: "pointer",
                                }}
                                onClick={() => window.open(value, "_blank")}
                                alt="DXF File"
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      if (column.accessor === "signedPdfUrl" && !isEmployee) {
                        return (
                          <TableCell key={column.id}>
                            {!isEmployee ? (
                              <button
                                style={{
                                  backgroundColor: "#157CB3",
                                  color: "#fff",
                                  padding: "8px 16px",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  opacity: 1,
                                }}
                                type="button"
                                onClick={handleSign}
                                disabled={isEmployee}
                              >
                                Attach Digital Sign
                              </button>
                            ) : value ? (
                              <FaFilePdf
                                color="#a10505"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleOpenPdf(value, index)}
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      return <TableCell key={column.id}>{value || "N/A"}</TableCell>;
                    })}
                  </TableRow>
                ))
              ) : (
                <TableRow key={1}>
                  {pdfcolumns.map((column, index) => {
                    if (column.id === "submissionIndex") {
                      return <TableCell key={index}>Upload Drawing PDF {index + 1}</TableCell>;
                    }
                    if (column.accessor === "dxfFile") {
                      return (
                        <TableCell>
                          {scrutinydxf?.[0]?.fileStoreId ? (
                            <FaFilePdf
                              color="#a10505"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => getDocumentByFileStoreId(scrutinydxf?.[0]?.fileStoreId, setIsPreviewLoading)}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                    if (column.accessor === "drawingPdf") {
                      return (
                        <TableCell>
                          {scrutinydxf?.[0]?.fileStoreId ? (
                            <FaFilePdf
                              color="#a10505"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => getDocumentByFileStoreId(drawingPdfflow?.[0]?.fileStoreId, setIsPreviewLoading)}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                    if (column.accessor === "signedPdfUrl") {
                      return (
                        <TableCell>
                          {!isEmployee ? (
                            <button
                              style={{
                                backgroundColor: "#157CB3",
                                color: "#fff",
                                padding: "8px 16px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                opacity: 1,
                              }}
                              type="button"
                              onClick={handleSign}
                              disabled={isEmployee}
                            >
                              Attach Digital Sign
                            </button>
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* PDF Viewer Modal */}
        <PdfViewerModal
          open={pdfModalOpen}
          onClose={handlePdfModalClose}
          pdfUrl={currentPdfUrl}
          onSave={handlePdfSave}
          documentIndex={currentDocumentIndex}
        />
        {/* Modal overlay */}
        <div
          style={{
            display: open ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "95%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          {/* Modal content remains unchanged */}
        </div>
        {!isEmployee && !isNocModule && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="button"
                onClick={() => handleTabChange(3)}
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default Step3;
